<template>
  <div class="my-2 px-2 w-full autocomplete relative inline-block" :class="classes" >
    <Combobox as="div" class="w-full block mx-auto sm:text-smw-full block mx-auto sm:text-sm" @update:modelValue="onSelect2">
      <ComboboxInput
          class="w-full block mx-auto sm:text-sm" :value="this.campaignSearch"
          :placeholder="placeholderText" @change="campaignSearch = $event.target.value"  />

      <ComboboxOptions v-if="campaigns.length > 0" static class="-mb-2 max-h-72 scroll-py-2 overflow-y-auto py-2 text-sm text-gray-800">
        <ComboboxOption v-for="campaign in campaigns" :key="campaign.id" :value="campaign" as="template" v-slot="{ active }">
          <li :class="['cursor-default select-none rounded-md px-4 py-2', active && 'bg-indigo-600 text-white']">
            {{ campaign.name }} ({{ campaign.id }})
          </li>
        </ComboboxOption>
      </ComboboxOptions>

      <div v-if="this.searching" class="py-14 px-4 text-center sm:px-14">
<!--        <DocumentSearchIcon class="mx-auto h-6 w-6 text-gray-400" aria-hidden="true" />-->
        <p class="mt-4 text-sm text-gray-900">Searching...</p>
      </div>


      <div v-if="this.noResultFound" class="py-14 px-4 text-center sm:px-14">
        <DocumentSearchIcon class="mx-auto h-6 w-6 text-gray-400" aria-hidden="true" />
        <p class="mt-4 text-sm text-gray-900">No campaign found using that search term.</p>
      </div>
    </Combobox>

    </div>

</template>

<script>
    import { computed, ref } from 'vue'
    import { DocumentSearchIcon } from '@heroicons/vue/outline'
    import _ from 'lodash'
    import {
      Combobox,
      ComboboxInput,
      ComboboxOptions,
      ComboboxOption,
      Dialog,
      DialogOverlay,
      TransitionChild,
      TransitionRoot,
    } from '@headlessui/vue'

    const API_URL = '/campaign-search-auto-complete?query=:query'

    export default {
        components: {
          Combobox,
          ComboboxInput,
          ComboboxOptions,
          ComboboxOption,
          Dialog,
          DialogOverlay,
          DocumentSearchIcon,
          TransitionChild,
          TransitionRoot,
        },
      setup() {
        const open = ref(true)
        const query = ref('')
        // const filteredCampaign = computed(() =>
        //     query.value === ''
        //         ? []
        //         : this.campaigns.filter((campaign) => {
        //           return campaign.name.toLowerCase().includes(query.value.toLowerCase())
        //         })
        // )

        return {
          open,
          query,
          // filteredCampaign,
          // onSelect(person) {
          //   window.location = person.url
          // },
        }
      },
      props: {
        classes: null,
        showOnlyTopLevelCampaigns: {
          type: Boolean,
          default: true
        }
      },
        data() {
            return {
              searching: false,
              campaigns: [],
              campaignSearch: '',
              selectedCampaign: null,
              noResultFound: false
            };
        },
        methods: {
          onSelect2(campaign) {
            this.selectedCampaign = campaign
          },

          async getCampaigns(query) {
              const res = await fetch(API_URL.replace(':query', query))
              const allCampaigns = await res.json()
              // Filter campaigns based on prop
              if (this.showOnlyTopLevelCampaigns) {
                // Only show foundation campaigns (parent_id is null)
                this.campaigns = allCampaigns.filter(campaign => campaign.parent_id === null)
              } else {
                // Show all campaigns
                this.campaigns = allCampaigns
              }
              this.noResultFound = this.campaigns.length === 0
              this.searching = false
          },

          fetchCampaigns: _.debounce(function () {

            this.searching = true
              this.getCampaigns(this.campaignSearch)
          }, 500)
        },

        watch: {
          selectedCampaign() {
                this.emitter.emit('search-selected-campaign', this.selectedCampaign)
                this.searching = false
                this.campaignSearch =  this.selectedCampaign.name

                this.campaigns = [] //reset so we can close the list display
            },
          campaignSearch() {
            this.noResultFound = false

            if (this.campaignSearch.length <= 3) {
              return
            }
            if (this.selectedCampaign && this.campaignSearch === this.selectedCampaign.name) {
              return
            }
            this.fetchCampaigns()

            }
        },

        computed: {
          placeholderText() {
            return this.showOnlyTopLevelCampaigns 
              ? "Search for a foundation campaign (top-level campaigns only)..." 
              : "Search for any campaign...";
          }
        },
    }
</script>
